import React from 'react';

/**
 * Surface card: radius-lg, subtle border + navy-tinted shadow.
 * Adapts to dark mode automatically through `.opt-dark` token overrides.
 * Set `hover` for a lift effect on interactive cards.
 */
export function Card({ hover = false, className = '', children, ...rest }) {
  const classes = ['opt-card', hover ? 'opt-card--hover' : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}

export default Card;
